import { Attr, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';

@Model()
export default class SplitTest extends ApplicationRecord {
  static jsonapiType = 'split_tests';

  @Attr() name: string;
  @Attr() active: boolean;
  @Attr() createdAt: string;
  @Attr() updatedAt: string;
}
